import React from 'react'; // eslint-disable-line no-unused-vars
import { select } from 'redux-saga/effects';

import { changeBoard } from '../events';
// eslint-disable-next-line import/no-cycle
import store from '../store';
import * as actions from '../state';

import hideBoardService from './services/board/hideBoard';
import fetchBoardListService from './services/board/fetchBoardList';

export default function* favoriteBoard(event) {
  try {
    const user = yield select((state) => actions.readStateUser(state));

    const { intl } = event.payload;
    const { messages } = event.payload;

    const hideService = hideBoardService({
      user: user.userId,
      domain: user.domain,
      board: event.payload.board,
    });

    hideService.then((result) => {
      try {
        if (!result) {
          throw intl.formatMessage({ ...messages.HIDE_FAILED });
        }

        fetchBoardListService({ // update boardlist
          user: user.userId,
          domain: user.domain,
        }).then((boardList) => {
          store.dispatch(actions.setBoardList(boardList));
          store.dispatch(changeBoard(boardList[0].id));
          store.dispatch(actions.isDirty(false));
          store.dispatch(actions.savedBoardState(false));
          store.dispatch(actions.editMode(false));
        });
      } catch (error) {
        store.dispatch(actions.showToaster({
          show: true,
          type: 'error',
          message: error,
        }));
      }
    });
  } catch (error) {
    store.dispatch(actions.showToaster({
      show: true,
      type: 'error',
      message: error,
    }));
  }
}
